"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRACKING_QUERY_FIELDS = void 0;
exports.trackingQueryParameters = trackingQueryParameters;
exports.sanitizeTrackingSourceUrl = sanitizeTrackingSourceUrl;
/** Public campaign parameters only; never propagate arbitrary checkout query data. */
exports.TRACKING_QUERY_FIELDS = [
    ['utm_source', 'source'],
    ['utm_medium', 'medium'],
    ['utm_campaign', 'campaign'],
    ['utm_content', 'content'],
    ['utm_term', 'term'],
    ['sck', 'sck'],
    ['src', 'src'],
];
function trackingQueryParameters(utm, ids) {
    const values = {};
    for (const [query, field] of exports.TRACKING_QUERY_FIELDS) {
        const value = utm?.[field]?.trim();
        if (value)
            values[query] = value;
    }
    for (const field of ['fbclid', 'ttclid', 'gclid']) {
        const value = ids?.[field]?.trim();
        if (value)
            values[field] = value;
    }
    return values;
}
function sanitizeTrackingSourceUrl(raw) {
    if (!raw || raw.length > 8192)
        return undefined;
    try {
        const url = new URL(raw);
        if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password)
            return undefined;
        const allowed = new Set([
            ...exports.TRACKING_QUERY_FIELDS.map(([key]) => key),
            'fbclid',
            'ttclid',
            'gclid',
        ]);
        const search = new URLSearchParams();
        for (const key of allowed) {
            const value = url.searchParams.get(key)?.trim();
            if (value)
                search.set(key, value);
        }
        url.search = search.toString();
        url.hash = '';
        const result = url.toString();
        return result.length <= 8192 ? result : undefined;
    }
    catch {
        return undefined;
    }
}
//# sourceMappingURL=tracking-attribution.js.map